<template>
  <div>
      <v-dialog max-width="350" v-model="SEOBasicsDialog">
        <v-card tile flat width="100%">
            <v-card-title>
            </v-card-title>
            <v-card-text>
                <v-switch label="Page Shows on Web Searches" v-model="SEOPage.SEO"
                />
                <ContentEditableField style="padding:15px;"
                :FieldObject="SEOPage" :FieldName="'Overview'"
                :FieldValue="SEOPage.Overview" @UpdateContentEditableField="UpdateContentEditableField" :AdditionalSaveMethod="''" />
                <v-combobox
                        v-model="SEOPage.KeyWords"
                        :items="KeyWords"
                        label="KeyWords"
                        multiple
                        chips
                        >
                </v-combobox>
            </v-card-text>
            <v-card-text  v-if="SEOPage.SEO">
                Web Preview
                <v-list-item style="width:100%;padding-top:10px;padding-left:20px;border: 1px solid #ccc !important;" three-line> 
                                       
                    <v-list-item-content>
                        <v-list-item-title class="caption" style="margin-bottom:-6px;">{{DefaultPath+SEOPage.PageRoute}}</v-list-item-title>
                        <v-list-item-subtitle class="text-h7">
                        <v-btn  class="underlinehover" style="padding-left:0px;text-transform: capitalize;font-size: 0.925em;color: #1a0dab!important;" text plain depressed>
                            <span>{{System.Name}} || </span>
                        <span v-if="ActiveGroup && IsGroupView">{{ActiveGroup.name}} || </span> {{SEOPage.Name}} <v-icon color="#1a0dab" small dark>{{SEOPage.PageIcon}}</v-icon></v-btn>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle style="display: block;" v-html="SEOPage.Overview">
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="DeactivateSEODialog()" dark color="warning">
                    Cancel</v-btn>
                    <v-spacer>
                    </v-spacer>
                    <v-btn  @click="UpdateSEOBasics()"  dark color="success">
                        Save
                    </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-navigation-drawer dark :app="!MiniView" hide-overlay
    v-model="SiteDialog" color="rgb(145,105,152)"
    :permanent="!MiniView" mini-variant-width="100"
    :style="!$route.meta.DataSingleBuilder? 'z-index:8;height: 100%;top:10px;position: fixed;padding-bottom:100px;'
    : 'z-index:2;height: 100%;top:60px;position: fixed;'"
    >	
    <v-layout style="padding-right:10px;margin-top: 60px;" align-center>
      <!-- <div class="cloudbg" :style="NavbarStyling"/> -->
      <!-- <v-flex class="mt-5 hidden-sm-and-down"> -->
        <v-flex xl6>
          <v-tooltip bottom max-width="200">
          <template v-slot:activator="{ on, attrs }">
          <v-progress-circular v-on="on" v-bind="attrs"
      :rotate="360"
      :size="100"
      :width="15"
      :value="progressvalue"
      color="rgb(211,233,217)"
    >
    3/5
    </v-progress-circular>
          </template>
          <span v-html="ActiveViewItem ? ActiveViewItem.Toolip : 'Select an item'">
          </span>
          </v-tooltip>
        </v-flex>
         <v-flex xl6 class="white--text">
          Let's set up your Suite
        </v-flex>
      </v-layout>
        <v-divider></v-divider>
        <v-list dense>
            <v-list-item dense class="overline">
                General
            </v-list-item>
            <v-list-item dense 
            v-for="main in FilteredTopItems"
            :key="main.itemObjKey" style="padding-left:30px;"
            @click="ActivateSelectedMain(main)"
            >
            <v-list-item-title>
                <!--class="settingsfont"  -->
                <v-icon small style="padding-right: 5px;">{{main.icon}}</v-icon>
                {{main.title}}
                    <v-badge color="warning" v-if="main.notifications" left>
                <span slot="badge"> {{main.notifications}}</span>
                </v-badge>
            </v-list-item-title>
            </v-list-item>
            <!-- <v-list-item dense class="overline">
                Plugins Config
            </v-list-item>
            <v-list-item dense 
            v-for="main in FilteredPluginItems"
            :key="main.itemObjKey" style="padding-left:30px;"
            @click="ActivateSelectedMain(main)"
            >
            <v-list-item-title>
                <v-icon small style="padding-right: 5px;">{{main.icon}}</v-icon>
                {{main.title}}
                    <v-badge color="warning" v-if="main.notifications" left>
                <span slot="badge"> {{main.notifications}}</span>
                </v-badge>
            </v-list-item-title>
            </v-list-item> -->
        </v-list>
        <v-divider></v-divider>
         <v-list dense>
            <v-list-item dense class="overline">
                Apps
            </v-list-item>
            <v-list-item dense class="settingsfont">
               <v-chip small @click="ToggleNewAppDialog()" >Add <v-icon small>mdi-plus</v-icon></v-chip>
            </v-list-item>
            <v-list-item dense 
            v-for="main in RegisteredApps"
            :key="main.itemObjKey" style="padding-left:30px;"
            :to="'/App/'+main.id"
            >
            <v-list-item-title>
                <v-icon small style="padding-right: 5px;">{{main.Icon}}</v-icon>
                {{main.Name}}
                    <v-badge color="warning" v-if="main.notifications" left>
                <span slot="badge"> {{main.notifications}}</span>
                </v-badge>
            </v-list-item-title>
            </v-list-item>
        </v-list>
        <!-- <v-divider></v-divider>
        
         <v-list dense>
              <v-list-item dense class="overline">
                Modules
            </v-list-item>
            <v-list-item dense 
            v-for="main in ModulePluginsMenuItems"
            :key="main.itemObjKey" style="padding-left:30px;"
            @click="ActivateSelectedMain(main)"
            ><v-list-item-title>
                <v-icon small style="padding-right: 5px;">{{main.Icon}}</v-icon>
                {{main.Name}}
                    <v-badge color="warning" v-if="main.notifications" left>
                <span slot="badge"> {{main.notifications}}</span>
                </v-badge>
                </v-list-item-title>
            </v-list-item>
        </v-list> -->
        <!-- <v-divider></v-divider>
        <v-list dense>
            <v-list-item dense class="overline">
                Featured
            </v-list-item>
            <v-list-item dense 
            v-for="main in PluginTypesFeatured"
            :key="main.itemObjKey" style="padding-left:30px;"
            @click="ActivateSelectedMain(main)"
            >
            <v-list-item-title>
                <v-icon small style="padding-right: 5px;">{{main.icon}}</v-icon>
                {{main.title}}
                    <v-badge color="warning" v-if="main.notifications" left>
                <span slot="badge"> {{main.notifications}}</span>
                </v-badge>
            </v-list-item-title>
            </v-list-item>
        </v-list> -->
        </v-navigation-drawer>
  </div>
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'
import ContentEditableField from '@/components/Database/ContentEditableField'
import AssetsDirectory from '@/components/WebPages/ConfigComponents/AssetsDirectory';	
import AppStylingComponent from '@/components/SuiteBuilder/AppStylingComponent';	
import GroupMembers from "@/components/SuitePlugins/Groups/GroupMembers";
import RAPluginCarousel from '@/components/WebPages/RenderComponents/RAPluginCarousel';

export default { 
    props: ['System','SystemEntities','SitePages','SocialEntities','SystemPhotoLibraries','WebFormEntities','GroupEntities','GraphicalElements','GradientElements','DocumentationLibraries'],
    components: {
        ContentEditableField,
        AssetsDirectory,
        AppStylingComponent,
        GroupMembers,
        RAPluginCarousel
    },
    data() {
        return {
            systemguideelmnt: {			
              HideGuidesCarousel: false,						
                RowColor: '#00ffff',									
                Name: 'System Guide',									
                ShowComponents: true,									
                Icon: 'mdi-card-text',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus. Commune scaevola imperdiet`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,		
                Elevation: 6,
                BoxTransparency: '',
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },
            MemberSearch: '',
            PredialQuickSelectItems: [
                {title: 'Social Components', Writeup: `<p>General Social Network settings for your App</p>`,IMG: require('@/assets/logo.png'),},
            ],
            PluginItems: [
                { title: 'Chatbot', icon: 'mdi-robot',Route: 'ChatbotBuilder',Accepted: ['Chatbot']}, 
                { title: 'FAQ', icon: 'mdi-account-question',Route: 'FAQAdmin',Accepted: ['FAQ']},
                { title: 'Glossary', icon: 'mdi-file-word',Route: 'Glossary',Accepted: ['Glossary']},
                //{ title: 'Web Forms', icon: 'mdi-form-select',Route: 'Glossary',Accepted: ['Web_Forms']},    
            ],
            TopItems: [
                { title: 'Home', icon: 'mdi-home',Menu: false,Method: 'SelectSuiteBuilderNavItem',PropisSelf: true,},  
                { title: 'Subscriptions', icon: 'mdi-webpack',Menu: false,Method: 'SelectSuiteBuilderNavItem',PropisSelf: true,},
                { title: 'Statistics', icon: 'mdi-chart-box',Menu: false,Method: 'SelectSuiteBuilderNavItem',PropisSelf: true,},          
                { title: 'Settings', icon: 'mdi-cogs',Menu: false,Method: 'SelectSuiteBuilderNavItem',PropisSelf: true,},
                { title: 'Members', icon: 'mdi-account',Menu: false,Method: 'SelectSuiteBuilderNavItem',PropisSelf: true,},
                // { title: 'Security', icon: 'mdi-server-security',Menu: false,Method: 'SelectSuiteBuilderNavItem',PropisSelf: true,},
                { title: 'Web Forms', icon: 'mdi-form-select',Menu: false,Method: 'SelectSuiteBuilderNavItem',PropisSelf: true,Accepted: ['Web_Forms']}, 
                // { title: 'Libraries', icon: 'mdi-library-shelves',Menu: false,Method: 'SelectSuiteBuilderNavItem',PropisSelf: true,},   
                //  { title: 'Chatbot', icon: 'mdi-robot',Route: 'ChatbotBuilder',Accepted: ['Chatbot'] ,
                // PreDialog: true,
                // IMG: require('@/assets/logo.png'),
                // Writeup: `<p>Capitalize on FAQ and configure chatbot for responses. Further expand the chatbot with "virtual assist" responses such as "How many Orders were placed last week".</p>`,},
                 ],
            // PluginTypesFeatured: [
            //      { title: 'Goods & Orders', icon: 'mdi-cart',Menu: false,Method: 'SelectSuiteBuilderNavItem',PropisSelf: true,},
            //      { title: 'Directories & Personals', icon: 'mdi-view-list',Menu: false,Method: 'SelectSuiteBuilderNavItem',PropisSelf: true,},
            //      { title: 'Service Providing', icon: 'mdi-hand-heart',Menu: false,Method: 'SelectSuiteBuilderNavItem',PropisSelf: true,},
            //      { title: 'Team', icon: 'mdi-account-group',Menu: false,Method: 'SelectSuiteBuilderNavItem',PropisSelf: true,},
            // ],
            GalleryLibraries: [],
            FontOptions: ['Architects Daughter','Bahianita','Bangers','Bebas Neue','Berkshire Swash','Caveat','Courgette','Dancing Script','Gudea','Hind','Impact','Indie Flower','Lato','Lobster','Macondo Swash Caps','Maven Pro','Metrophobic','Michroma','Montserrat','Mulish','Mukta Vaani',
                  'News Cycle','Niramit','NTR','Nunito Sans','Oswald','Padauk','Palanquin','Parisienne','Playfair Display','Poiret One','Poppins','Quicksand','Raleway','Redressed','Tangerine','Tulpen One','Verdana','Vibes','Yellowtail'],									
        
            
        SEOPage: {
            Overview: '',
            PageRoute: '',
            KeyWords: [],
            Name: '',
            PageIcon: '',
            SEO: false,
        },
        DefaultSEOPage: {
            Overview: '',
            PageRoute: '',
            KeyWords: [],
            Name: '',
            PageIcon: '',
            SEO: false,
        },
        SEOBasicsDialog: false,
        PageBasics: [
            {Label: 'Rename', Prop: 'PageName', Icon: 'mdi-pencil', Menu: false},
            {Label: 'Path', Prop: 'PageRoute', Icon: 'mdi-link', Menu: false},
            {Label: 'Rename', Prop: 'PageIcon', Icon: 'mdi-circle', Menu: false}
        ],
        NavItemIndex: -1,
        SelectedNavbar: '',
        SelectedPage: '',
        SelectedMain: '',
        SelectedMainDialog: false,
        STDCSSColors: [{Name: 'aliceblue', HEX: '#f0f8ff'},{Name: 'antiquewhite', HEX: '#faebd7'},{Name: 'aqua', HEX: '#00ffff'},{Name: 'aquamarine', HEX: '#7fffd4'},{Name: 'azure', HEX: '#f0ffff'},{Name: 'beige', HEX: '#f5f5dc'},{Name: 'bisque', HEX: '#ffe4c4'},{Name: 'black', HEX: '#000000'},{Name: 'blanchedalmond', HEX: '#ffebcd'},{Name: 'blue', HEX: '#0000ff'},{Name: 'blueviolet', HEX: '#8a2be2'},{Name: 'brown', HEX: '#a52a2a'},{Name: 'burlywood', HEX: '#deb887'},{Name: 'cadetblue', HEX: '#5f9ea0'},{Name: 'chartreuse', HEX: '#7fff00'},{Name: 'chocolate', HEX: '#d2691e'},{Name: 'coral', HEX: '#ff7f50'},{Name: 'cornflowerblue', HEX: '#6495ed'},{Name: 'cornsilk', HEX: '#fff8dc'},{Name: 'crimson', HEX: '#dc143c'},{Name: 'cyan', HEX: '#00ffff'},{Name: 'darkblue', HEX: '#00008b'},{Name: 'darkcyan', HEX: '#008b8b'},{Name: 'darkgoldenrod', HEX: '#b8860b'},{Name: 'darkgray', HEX: '#a9a9a9'},{Name: 'darkgreen', HEX: '#006400'},{Name: 'darkgrey', HEX: '#a9a9a9'},{Name: 'darkkhaki', HEX: '#bdb76b'},{Name: 'darkmagenta', HEX: '#8b008b'},{Name: 'darkolivegreen', HEX: '#556b2f'},{Name: 'darkorange', HEX: '#ff8c00'},{Name: 'darkorchid', HEX: '#9932cc'},{Name: 'darkred', HEX: '#8b0000'},{Name: 'darksalmon', HEX: '#e9967a'},{Name: 'darkseagreen', HEX: '#8fbc8f'},{Name: 'darkslateblue', HEX: '#483d8b'},{Name: 'darkslategray', HEX: '#2f4f4f'},{Name: 'darkslategrey', HEX: '#2f4f4f'},{Name: 'darkturquoise', HEX: '#00ced1'},{Name: 'darkviolet', HEX: '#9400d3'},{Name: 'deeppink', HEX: '#ff1493'},{Name: 'deepskyblue', HEX: '#00bfff'},{Name: 'dimgray', HEX: '#696969'},{Name: 'dimgrey', HEX: '#696969'},{Name: 'dodgerblue', HEX: '#1e90ff'},{Name: 'firebrick', HEX: '#b22222'},{Name: 'floralwhite', HEX: '#fffaf0'},{Name: 'forestgreen', HEX: '#228b22'},{Name: 'fuchsia', HEX: '#ff00ff'},{Name: 'gainsboro', HEX: '#dcdcdc'},{Name: 'ghostwhite', HEX: '#f8f8ff'},{Name: 'gold', HEX: '#ffd700'},{Name: 'goldenrod', HEX: '#daa520'},{Name: 'gray', HEX: '#808080'},{Name: 'green', HEX: '#008000'},{Name: 'greenyellow', HEX: '#adff2f'},{Name: 'grey', HEX: '#808080'},{Name: 'honeydew', HEX: '#f0fff0'},{Name: 'hotpink', HEX: '#ff69b4'},{Name: 'indianred', HEX: '#cd5c5c'},{Name: 'indigo', HEX: '#4b0082'},{Name: 'ivory', HEX: '#fffff0'},{Name: 'khaki', HEX: '#f0e68c'},{Name: 'lavender', HEX: '#e6e6fa'},{Name: 'lavenderblush', HEX: '#fff0f5'},{Name: 'lawngreen', HEX: '#7cfc00'},{Name: 'lemonchiffon', HEX: '#fffacd'},{Name: 'lightblue', HEX: '#add8e6'},{Name: 'lightcoral', HEX: '#f08080'},{Name: 'lightcyan', HEX: '#e0ffff'},{Name: 'lightgoldenrodyellow', HEX: '#fafad2'},{Name: 'lightgray', HEX: '#d3d3d3'},{Name: 'lightgreen', HEX: '#90ee90'},{Name: 'lightgrey', HEX: '#d3d3d3'},{Name: 'lightpink', HEX: '#ffb6c1'},{Name: 'lightsalmon', HEX: '#ffa07a'},{Name: 'lightseagreen', HEX: '#20b2aa'},{Name: 'lightskyblue', HEX: '#87cefa'},{Name: 'lightslategray', HEX: '#778899'},{Name: 'lightslategrey', HEX: '#778899'},{Name: 'lightsteelblue', HEX: '#b0c4de'},{Name: 'lightyellow', HEX: '#ffffe0'},{Name: 'lime', HEX: '#00ff00'},{Name: 'limegreen', HEX: '#32cd32'},{Name: 'linen', HEX: '#faf0e6'},{Name: 'magenta', HEX: '#ff00ff'},{Name: 'maroon', HEX: '#800000'},{Name: 'mediumaquamarine', HEX: '#66cdaa'},{Name: 'mediumblue', HEX: '#0000cd'},{Name: 'mediumorchid', HEX: '#ba55d3'},{Name: 'mediumpurple', HEX: '#9370db'},{Name: 'mediumseagreen', HEX: '#3cb371'},{Name: 'mediumslateblue', HEX: '#7b68ee'},{Name: 'mediumspringgreen', HEX: '#00fa9a'},{Name: 'mediumturquoise', HEX: '#48d1cc'},{Name: 'mediumvioletred', HEX: '#c71585'},{Name: 'midnightblue', HEX: '#191970'},{Name: 'mintcream', HEX: '#f5fffa'},{Name: 'mistyrose', HEX: '#ffe4e1'},{Name: 'moccasin', HEX: '#ffe4b5'},{Name: 'navajowhite', HEX: '#ffdead'},{Name: 'navy', HEX: '#000080'},{Name: 'oldlace', HEX: '#fdf5e6'},{Name: 'olive', HEX: '#808000'},{Name: 'olivedrab', HEX: '#6b8e23'},{Name: 'orange', HEX: '#ffa500'},{Name: 'orangered', HEX: '#ff4500'},{Name: 'orchid', HEX: '#da70d6'},{Name: 'palegoldenrod', HEX: '#eee8aa'},{Name: 'palegreen', HEX: '#98fb98'},{Name: 'paleturquoise', HEX: '#afeeee'},{Name: 'palevioletred', HEX: '#db7093'},{Name: 'papayawhip', HEX: '#ffefd5'},{Name: 'peachpuff', HEX: '#ffdab9'},{Name: 'peru', HEX: '#cd853f'},{Name: 'pink', HEX: '#ffc0cb'},{Name: 'plum', HEX: '#dda0dd'},{Name: 'powderblue', HEX: '#b0e0e6'},{Name: 'purple', HEX: '#800080'},{Name: 'red', HEX: '#ff0000'},{Name: 'rosybrown', HEX: '#bc8f8f'},{Name: 'royalblue', HEX: '#4169e1'},{Name: 'saddlebrown', HEX: '#8b4513'},{Name: 'salmon', HEX: '#fa8072'},{Name: 'sandybrown', HEX: '#f4a460'},{Name: 'seagreen', HEX: '#2e8b57'},{Name: 'seashell', HEX: '#fff5ee'},{Name: 'sienna', HEX: '#a0522d'},{Name: 'silver', HEX: '#c0c0c0'},{Name: 'skyblue', HEX: '#87ceeb'},{Name: 'slateblue', HEX: '#6a5acd'},{Name: 'slategray', HEX: '#708090'},{Name: 'slategrey', HEX: '#708090'},{Name: 'snow', HEX: '#fffafa'},{Name: 'springgreen', HEX: '#00ff7f'},{Name: 'steelblue', HEX: '#4682b4'},{Name: 'tan', HEX: '#d2b48c'},{Name: 'teal', HEX: '#008080'},{Name: 'thistle', HEX: '#d8bfd8'},{Name: 'tomato', HEX: '#ff6347'},{Name: 'turquoise', HEX: '#40e0d0'},{Name: 'violet', HEX: '#ee82ee'},{Name: 'wheat', HEX: '#f5deb3'},{Name: 'white', HEX: '#ffffff'},{Name: 'whitesmoke', HEX: '#f5f5f5'},{Name: 'yellow', HEX: '#ffff00'},{Name: 'yellowgreen', HEX: '#9acd32'},
],
        sitenavitems: [
             { title: 'Add Content', icon: 'mdi-plus',Menu: false},
          { title: 'Site Menu & Pages', icon: 'mdi-home-city',Menu: false},
          { title: 'App Styling', icon: 'mdi-palette-advanced' ,Menu: false},
          { title: 'Page Design', icon: 'mdi-palette' ,Menu: false},
          { title: 'Media', icon: 'mdi-folder-image' ,Menu: false},
          { title: 'Plugins', icon: 'mdi-apps' ,Menu: false},
          { title: 'Group Members', icon: 'mdi-tag-faces' ,Menu: false},
          //the rest below are in fact plugin based. only relevant if plugins activated. 
          
          { title: 'Monetization', icon: 'mdi-cash-register' ,Menu: false, Route: 'Monetization',ORPlugins: ['Monetization'],
            PreDialog: true,
            IMG: require('@/assets/logo.png'),
            Writeup: `<p>Configure Monetization for the Social Network, earn and let your Users earn! Also used to configure an online Store</p>`
            },
           
          
          { title: 'Documentation Libraries', icon: 'mdi-book-education' ,Menu: false,ORPlugins: ['Documentation_Builder'], 
            },
           { title: 'FAQ', icon: 'mdi-account-question' ,Menu: false, Route: 'FAQAdmin',ORPlugins: ['FAQ'],
            PreDialog: true,
            IMG: require('@/assets/logo.png'),
            Writeup: `<p>Create and maintain a list of Frequently Asked Questions to add to your Website Pages</p>`
            },
            
            { title: 'Chatbot', icon: 'mdi-robot',Route: 'ChatbotBuilder',ORPlugins: ['Chatbot'] ,
            PreDialog: true,
            IMG: require('@/assets/logo.png'),
            Writeup: `<p>Capitalize on FAQ and configure chatbot for responses. Further expand the chatbot with "virtual assist" responses such as "How many Orders were placed last week".</p>`,},
            { title: 'Web Forms', icon: 'mdi-form-select' ,Menu: false, Route: 'WebForms',ORPlugins: ['Web_Forms']},
        ],
        }
    },
    computed:{
        IsPrimarySite(){
        return this.$store.state.ActiveSuiteid === process.env.VUE_APP_RA_SYSTEM_ID
      },
        RegisteredApps(){
            return this.$store.state.AppsDataBase
        },
        PluginTypesFeatured(){
            let array = []
            let featuredplugins = this.RAPlugins.filter(plug => {
                return plug.Featured
            })
            let featuredplugintypes = featuredplugins.map(item => {
            return item.Type
            })
            featuredplugintypes.map(type => {
            let oncheck = array.find(obj => obj.ID === type.ID)
            if(!oncheck){
                let menuobj = {
                    ID: type.ID,
                    title: type.Name,
                    icon: type.Icon,
                    Menu: false,
                    TypeFilter: type,
                    Method: 'SelectSuiteBuilderNavItem',PropisSelf: true
                }
                array.push(menuobj)
            }
            })
            //{ title: 'Goods & Orders', icon: 'mdi-cart',Menu: false,Method: 'SelectSuiteBuilderNavItem',PropisSelf: true,},
            return array
        },
        ModulePluginsMenuItems(){
            return this.ModulePlugins.map(plug => {
                let plugobj = Object.assign({},plug)
                plugobj.title = plug.Name
                plugobj.PropisSelf = true
                plugobj.Method = 'SelectSuiteBuilderNavItem'
                return plugobj
            }).filter(plug=>{
                if(plug.id === 'Database_Builder'){
                    return this.RegisteredApps.length > 0
                }
                else{
                    return plug
                }
            })
        },
        RelevantPlugins(){
        return this.SelectedModule ? this.SelectedModulePlugins : this.ModulePlugins
      },
        ModulePlugins(){
          return this.RAPluginsMatched(['Module'])
        },
        progressvalue(){
        return this.ActiveViewItem ? this.ActiveViewItem.Progress : 70
        },
        GroupMembersSearched(){
            return this.ActiveGroup && this.ActiveGroup.GroupMembers ?
            this.ActiveGroup.GroupMembers
            .map(member => {
              member.IsTeamMember = this.ActiveGroup.TeamMembers.includes(member.Userid) 
            let userobj = this.UsersArray.find(obj => obj.id == member.Userid)
            if(userobj && userobj.Profile_Photo){
            member.Profile_Photo = userobj.Profile_Photo
            }
            return member
            })
            .filter(member => {
                if(this.MemberSearch){
                return member.UserName.toLowerCase().includes(this.MemberSearch.toLowerCase()) 
                }
                else{
                return member
                }
            }) 
            : []
        },
        UsersArray(){
            return this.$store.state.UsersArray
        },
        RelatedGroupObj(){
            if(this.IsGroupView){
                return {
                    id: this.ActiveGroup,
                    name: this.ActiveGroup.name,
                    identifier: "name",
                    collection: "groups",
                    Link: "Group",
                }
            }
        },
        PluginDataBase(){
            return this.$store.state.PluginDataBase
        },
        ComputedBuilders(){
            return this.Builders.filter(builder => {
            return this.PluginDataBase[builder.Name.split(' ').join('_')] && this.PluginDataBase[builder.Name.split(' ').join('_')].Active
            })
        },
        WebsiteisActive(){
            return this.$store.state.WebsiteisActive
        },
        SocialNetworkisActive(){
            return this.$store.state.SocialNetworkisActive
        },
        DatabaseisActive(){
            return this.$store.state.DatabaseisActive
        },
        DocumentationisActive(){
            return this.$store.state.DocumentationisActive
        },
        MainDialRight(){
            return this.SelectedMain && this.SelectedMain.title === 'App Styling'
            || this.SelectedMain && this.SelectedMain.title === 'Group Members'
            || this.SelectedMain && this.SelectedMain.title === 'Plugins'
        },
        MainDialStyling(){
            if(this.SelectedMain && this.SelectedMain.title === 'App Styling'){
                return 'position: fixed;top:5px;z-index:6;height:80%;'
            }
            else if(this.SelectedMain && this.SelectedMain.title === 'Plugins'){
                if(this.$vuetify.breakpoint.xs){
                    return 'z-index: 6;width:300px;top:55px;padding-bottom:50px;'
                }
                else if(this.$vuetify.breakpoint.sm){
                    return 'z-index: 6;width:600px;top:55px;padding-bottom:50px;'
                }
                else{
                    return 'z-index: 6;width:65%;top:55px;padding-bottom:50px;'
                }
            }
            else if(this.SelectedMain && this.SelectedMain.title === 'Group Members'){
                return 'position: fixed;top:125px;z-index:6;height:80%;width: 350px;'
            }
            
            else{
                return 'position: fixed;left: 88px;top:125px;z-index:6;height:60%;'
            }
        },
        ActiveAppStylingNavbar(){
     if(this.$route.name === 'MyAccount'){
       return 'Guest Navbar'
     }
     else if(this.DBBuilderView){
        return 'DB Navbar'
      }
      else if(this.WebsiteBuilderView){
        if(this.$route.meta && this.$route.meta.DataSingleBuilder && this.$route.name !== 'SystemConfig'){
          return 'DB Navbar'
        }
        else{
          return 'Public Navbar'
        }
      }
      else if(this.NetworkBuilderView){
        return 'Social Navbar'
      }
   },
        GroupidRoutes(){
            return this.$store.state.GroupidRoutes
        },
        GroupslugRoutes(){
            return this.$store.state.GroupslugRoutes
        },
        GroupID(){
            if(this.GroupidRoutes.includes(this.$route.name)){
                return this.$route.params.id
            }
            else if(this.$route.query && this.$route.query.GroupID){
                return this.$route.query.GroupID
            }
            else if(this.GroupslugRoutes.includes(this.$route.name)){
                return this.$route.params.slug
            }
        },
        WebForms(){
            if(this.IsGroupView){
                return this.GroupEntities.filter(ent => {
                    return ent.Entity_Type && ent.Entity_Type.Name === 'Web Form' && ent.groupid === this.GroupID
                })
            }
            else{
                return this.WebFormEntities
            }
        },
        FilteredPluginItems(){
            return this.PluginItems.filter(topitem => {
            let pass = true
            if(topitem.Accepted){
               topitem.Accepted.map(plugid => {
                 if(!this.PluginDataBase[plugid] || this.PluginDataBase[plugid] && !this.PluginDataBase[plugid].Active){
                     pass = false
                 }  
               })               
            }
            return pass
            })
        },
        FilteredTopItems(){
            return this.TopItems.filter(item => {
                if(item.Accepted){
                    let pass = false
                    item.Accepted.map(acpt => {
                        if(this.PluginDataBase[acpt] && this.PluginDataBase[acpt].Active){
                            pass = true
                        }
                    })
                    return pass
                }
                else{
                    return item
                }
            }).filter(item => {
                return this.IsPrimarySite || item.title !== 'Home'
            })
        },
        IsGroupView(){
        return this.$store.state.IsGroupView
    },
        draggingtab(){
            return this.$store.state.draggingtab
        },
        draggingtabindex(){
            return this.$store.state.draggingtabindex
        },
        draggingelement(){
            return this.$store.state.draggingelement
        },
        draggingelementindex(){
            return this.$store.state.draggingelementindex
        },
        draggingrow(){
            return this.$store.state.draggingrow
        },
        draggingrowindex(){
            return this.$store.state.draggingrowindex
        },
        dragging(){
            return this.$store.state.dragging
        },
        NavbarItems(){
            if(this.IsGroupView){
                return [{Name: 'Group',Prop: 'GroupNavbarItems',PublishType: ''}]
            }
            else{
                return [{Name: 'Public',Prop: 'PublicNavbarItems',PublishType: 'Public'},{Name: 'Social',Prop: 'SocialNavbarItems',PublishType: 'Members Only'}]
            }
        },
        PageTabsPropName(){
            if(this.$route.meta && this.$route.meta.DataSingleBuilder || this.$route.meta && this.$route.meta.SubColEntryViewer){
                return 'SingleBuildTabs'
            }   
            else if(this.$route.meta && this.$route.meta.ClassifiedListingBuilder){
                return 'ClassifiedTabs'
            }
            else if(this.$route.meta && this.$route.meta.WikiListingBuilder){
                return 'WikiTabs'
            }
            else{
                return 'PageTabs'
            }
        //return this.$route.meta && this.$route.meta.DataSingleBuilder || this.$route.meta && this.$route.meta.SubColEntryViewer? 'SingleBuildTabs' : 'PageTabs'
    },		
        PageTabs(){
            console.log('EditedPage',this.EditedPage)
            return this.EditedPage ? this.EditedPage[this.PageTabsPropName] : []
        },
        EditedPage(){
            return this.$store.state.EditedPage
        },
        RenderedContentBlocks(){
            return this.$store.state.RenderedContentBlocks
        },
        BuilderView(){
        return this.$store.state.BuilderView
        },
        WebsiteBuilderView(){
            return this.BuilderView && this.BuilderView.Name === 'Website Builder'
        },
        DBBuilderView(){
            return this.BuilderView && this.BuilderView.Name === 'Database Builder'
        },
        NetworkBuilderView(){
            return this.BuilderView && this.BuilderView.Name === 'Social Network Builder'
        },
        SystemAssets(){
            return this.$store.state.SystemAssets
        },
        MiniView(){
            return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
        },
        SiteDialog(){
            return this.$store.state.SiteDialog
        },
        SelectedImage(){
        return this.$store.state.SelectedGalleryAsset
      },
      GroupScopeTabs(){
          return this.$store.state.GroupScopeTabs.map(item => {
              let itemobj = Object.assign({},item)
                itemobj.Method = 'AssignSocialItemInteractMethod'
                itemobj.Prop = 'ActivateSection'
                itemobj.SecondProp = {Prop: item.Prop}
                //console.log(item,itemobj)
              return itemobj
          })
      },
      SystemConfigTabs(){
        //console.log('SystemConfigTabs',this.$store.state.SystemConfigTabs)
        return this.$store.state.SystemConfigTabs
        },
      CurrentEntityTabs(){
        //console.log('CurrentEntityTabs',this.$store.state.CurrentDataTabs)
        return this.$store.state.CurrentDataTabs
        },
        DataTabsElementQuickselect(){
        return this.DataTabsElements.map(elmnt => {
            let elmntobj = {
                title: elmnt.DisplayName,
                icon: elmnt.Icon,
                ItemPass: true,
                Method: 'AssignSocialItemInteractMethod',
                Prop: 'ActivateSelectedElement',
                SecondProp: elmnt
                }
                // if(elmnt.PreDialog){
                //     elmntobj.PreDialog = elmnt.PreDialog
                //     elmntobj.Writeup = elmnt.Writeup
                //     elmntobj.IMG = elmnt.IMG
                // }
                //SecondProp has to be parent tab as well, in order to reutrn parent tab and childtab and boom
                return elmntobj
        })
        },
        DataTabsElements(){
            let arr = []
        //console.log('SystemConfigTabs',this.SystemConfigTabs)
        if(this.SystemConfigTabs){
            arr = this.SystemConfigTabs
            .filter(tab => {
                return tab.Name === 'Social Components'
            })
            //console.log(arr)
            if(this.DBBuilderView){
              arr = arr.map(tab => {          
            return tab.Elements
            .map((elmnt) => {
                let parenttabobj = Object.assign({},tab)            
                let elmntobj = Object.assign({},elmnt)
                if(this.NetworkBuilderView){
                    let iconitem = this.SocialIcons.find(obj => obj.Name === elmnt.Name)
                    if(iconitem){
                      elmntobj.Icon = iconitem.Icon   
                    }                   
                }
                elmntobj.FlexXLRG = 12								
                elmntobj.FlexLarge = 12									
                elmntobj.FlexMedium = 12									
                elmntobj.FlexSmall = 12									
                elmntobj.FlexXSmall = 12
                parenttabobj.Elements = [elmntobj]
                elmntobj.ParentTab = parenttabobj
                return elmntobj
            })
            }).flat()  
            }
            else{
                let socialgeneral = arr.map(tab => {
                    let parenttabobj = Object.assign({},tab)
                    parenttabobj.Elements = parenttabobj.Elements.slice(0,1)
                    parenttabobj.ParentTab = parenttabobj
                    parenttabobj.Icon = 'mdi-cogs'
                    return parenttabobj
                })
                let socialscope = arr.map(tab => {
                    let parenttabobj = Object.assign({},tab)
                    parenttabobj.Elements = parenttabobj.Elements.slice(1,parenttabobj.Elements.length)                    
                    parenttabobj.ParentTab = parenttabobj
                    parenttabobj.Icon = 'mdi-toggle-switch'
                    return parenttabobj
                })
                //console.log(socialgeneral,socialscope)
                arr = socialgeneral.concat(socialscope)
            }
            
        }
            return arr.map(item => {
                let itemobj = Object.assign({},item)
                let responseitem = this.PredialQuickSelectItems.find(obj => obj.title === itemobj.Name)
                //console.log(responseitem,itemobj)
                if(responseitem){
                    itemobj.PreDialog = true
                    itemobj.IMG = responseitem.IMG
                    itemobj.Writeup = responseitem.Writeup
                    if(itemobj.Name === 'Social Components' && itemobj.ParentTab && itemobj.ParentTab.Elements && itemobj.ParentTab.Elements.length === 1){
                        itemobj.Writeup = `<p>General Social Network settings for your App</p>`
                    }
                    else if(itemobj.Name === 'Social Components'){
                        //meaning th longer one
                        itemobj.Writeup = `<p>Configure  the Content Scope of your Social Network, such as whether or not you have Blogs, or Meetups, etc.</p>`
                    }
                }
                return itemobj
            })
        },
        
        ActiveGroup(){
            return this.$store.state.ActiveGroup
        },
        ComputedSitePages(){
            if(this.IsGroupView){
                return this.ActiveGroup && this.ActiveGroup.Pages ? this.ActiveGroup.Pages : []
            }
            else{
                return this.SitePages
            }
        },
        NavListArray(){
            return this[this.NavlistHolder] && this.SelectedNavbar && this[this.NavlistHolder][this.SelectedNavbar.Prop] ? this[this.NavlistHolder][this.SelectedNavbar.Prop]
            : []
        },
        NavlistRef(){
            return this.NavlistHolder === 'ActiveGroup' && this.ActiveGroup ? db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.ActiveGroup.id) : 
            db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid)
        },
        NavlistHolder(){
            if(this.IsGroupView){
                return 'ActiveGroup'
            }
            else{
                return 'System'
            }
        },
        ComputedNavList(){
            let arr = this.NavListArray
            console.log(arr)
            return arr.map((item,arrindex) => {
                item.MenuIndex = arrindex
                return item
            })
        },
        NavbarPages(){
            if(this.IsGroupView){
                return this.ComputedSitePages
            }
            else{
             return this.ComputedSitePages.filter(page => {
                     return page.PublishType === 'Members Only'
            })   
            }            
        },
        DefaultPath(){
            //UpdateSEOBasics
            if(this.$route.name === 'PageEditor'){
                return this.System.ClientAppURL+'/'
            }
            else if(this.IsGroupView){
                return this.System.ClientAppURL+'/Group-Page/'+this.GroupID+'/'
            }
        },
        userLoggedIn () {
        return this.$store.getters.user
        },
        userIsAdmin () {
            return this.$store.state.IsAdmin
        },
        WindowHeight(){
            return window.innerHeight
        },
        SocialItemInteractMethod(){
        return this.$store.state.SocialItemInteractMethod
        },
        SocialItemInteractMethodProp(){
            return this.$store.state.SocialItemInteractMethodProp
        },
        UnPaidPlugins(){
          return this.RAPlugins.filter(plug => {
              return this.PluginDataBase[plug.id] && !this.PluginDataBase[plug.id].Active
          })
      },
      PurchasablePlugins(){
          return this.RAPlugins.filter(plug => {
              return !this.PluginDataBase[plug.id] && plug.Strictly_One_Purchase || !plug.Strictly_One_Purchase
          })
      },
        RAPlugins(){
          return this.$store.state.RAPlugins
        },
        ComputedRAPlugins(){
            return this.RAPlugins.map(guide => {
                guide.elmnt = Object.assign({},this.systemguideelmnt)
                guide.elmnt.Description = guide.Description
                return guide
            })
        },
    },
    watch: {
        EditedPage : {
            handler: function(newvalue, oldvalue) {
                if(newvalue !== oldvalue && !oldvalue){
                    this.PrepNavbar(newvalue)
                    
                }
            },deep: true
        },
        SelectedMain (value){
            if(value){
                this.SelectedMainDialog = true
            }
            else{
                this.SelectedMainDialog = false
            }
        },
        SocialItemInteractMethod(v){   
        let acceptedmethods = []   
        if(v && acceptedmethods.includes(v)){
          if(this.SocialItemInteractMethodProp){
            this[this.SocialItemInteractMethod](this.SocialItemInteractMethodProp)
            if(this.SocialItemInteractMethod === 'ActivateSelectedElement'){
              this.SingleRecordNavMenuItem = ''
            }
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }
          else{ 
            this[this.SocialItemInteractMethod]()
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }          
        }
      },
    },
    created(){
    },
    methods:{
        ToggleNewAppDialog(){
            this.$emit('ToggleNewAppDialog')
        },
        RAPluginsMatched(categorymatches){
        let finalcategories = categorymatches.map(cat => {
          return cat.split(' & ')
        }).flat()
        return this.RAPlugins.filter(plug => {
          let plugcat = plug.Module_Category.Name.split(' & ').flat()
          return finalcategories.some(r=> plugcat.includes(r))
          //|| plug.Module_Category.Name === 'General'
        })
      },
        AddDocumentationLibrary(PublishType){
             this.AssignSocialItemInteractMethod('ToggleNewDocLibDialog',PublishType)
        },
        ToggleTeamMemberStatus(member){
            if(member.IsTeamMember){
                member.RemovefromTeam = false
            }
            else{
                member.RemovefromTeam = true
            }
            member.RemovefromTeam = !member.RemovefromTeam
            this.SaveTeamMembers()
        },
        FeatureMember(member){
            this.$router.push({ name: 'FeaturedMemberEdit',query: {GroupType: this.ActiveGroup.GroupCategory.Name.split(' ').join('-')}, params: {id: member.Userid,slug: this.GroupID,groupname: this.ActiveGroup.name,groupid: this.GroupID,grouptype: this.ActiveGroup.GroupCategory}})
        },
        ConfirmActivateMember(member){
            console.log('member',member)
            confirm('This will deactive the user and revoke their permissions to the Group. Are you sure you want to continue?') && this.ProcessActivateMember(member)
        },
        ConfirmDeactivateMember(member){
            confirm('This will deactive the user and revoke their permissions to the Group. Are you sure you want to continue?') && this.ProcessDeactivateMember(member)
        },
        ProcessActivateMember(member){
            db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groupmembers').doc(member.id).collection('groups').doc(this.$route.params.id).update({
            Status: 'Active',
            MembershipDate: new Date(),
            MembershipRequestDate: new Date(member.MembershipDate)
            })
            member.Status = 'Active'
        },
        ProcessDeactivateMember(member){
            db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groupmembers').doc(member.id).collection('groups').doc(this.$route.params.id).update({
            Status: 'InActive',
            Follower: false,
            Administrator: false,
                BlogsModerator: false,
                ArticlesModerator: false,
                EventsModerator: false,
                PollsModerator: false,
                MeetupsModerator: false,
                ForumsModerator: false,
            })
        },
        SaveTeamMembers(){
        // console.log(this.ActiveGroup.GroupMembers,this.pushedgroupmembers)
        let addedmembers = this.ActiveGroup.GroupMembers.filter(member => {return this.ActiveGroup.GroupMembers.find(obj => obj.Userid === member.Userid && !obj.RemovefromTeam)})
        // console.log(addedmembers)
        let removedmembers = this.ActiveGroup.GroupMembers.filter(member => {return this.ActiveGroup.GroupMembers.find(obj => obj.Userid === member.Userid && obj.RemovefromTeam && !obj.Administrator)})
        // console.log(removedmembers)
        addedmembers.map(member => {
            db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groupmembers').doc(member.Userid).collection('groups').doc(this.GroupID).update({
            IsTeamMember: true
            })
        })
        let TeamMembers = addedmembers.map(member => {return member.Userid})
        db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
            TeamMembers: TeamMembers
        })
        
        },
        CancelDrag(){
            this.$store.commit('setdragging','') 
        },
        blockdragstart(block) {									
        //console.log(block)	
        this.$store.commit('setdragging',block) 								
        },
        HideTabElements(i){
            this.$store.commit('SetSocialItemInteractMethodProp',i) 
            this.$store.commit('SetSocialItemInteractMethod','HideTabElements')
        },
        ShowTabElements(i){
            //console.log(i)
            this.$store.commit('SetSocialItemInteractMethodProp',i) 
            this.$store.commit('SetSocialItemInteractMethod','ShowTabElements')
        },
        Elmntdragstart(tab,tabindex,elmnt,elmntindex){		
            //console.log(tab,tabindex,elmnt,elmntindex)	
            this.$store.commit('setdraggingtab',tab) 
            this.$store.commit('setdraggingtabindex',tabindex)
            this.$store.commit('setdraggingelement',elmnt)
            this.$store.commit('setdraggingelementindex',elmntindex)								
        },									
        Elmntdragfinish(to,ev){							
            //console.log(this.draggingrow)							
            this.PageTabs[this.draggingtabindex].Elements.splice(to, 0, this.PageTabs[this.draggingtabindex].Elements.splice(this.draggingelementindex, 1)[0]);	
            this.$store.commit('SetSocialItemInteractMethodProp',to)
            this.$store.commit('SetSocialItemInteractMethod','Elmntdragfinish')
        },
        Tabdragstart(row,rowindex){									
            this.$store.commit('setdraggingrow',row) 
            this.$store.commit('setdraggingrowindex',rowindex)				
        },									
        Tabdragfinish(to,ev){	
            this.$store.commit('SetSocialItemInteractMethodProp',to) 
            this.$store.commit('SetSocialItemInteractMethod','Tabdragfinish')								
            this.PageTabs.splice(to, 0, this.PageTabs.splice(this.draggingrowindex, 1)[0]);	
            this.$store.commit('SetSocialItemInteractMethodProp',to)
            this.$store.commit('SetSocialItemInteractMethod','Tabdragfinish')						
        },	
        GetGalleryObjects(){									
            let routes = this.$router.getRoutes()									
            let GalleryPaths = routes.filter(option => {return option.meta && option.meta.photolibrary})									
            //console.log('GalleryPaths',GalleryPaths)									
            GalleryPaths.map(path => {									
                this.GetGalleryItems(path)									
            })									
        },									
        GetGalleryItems(path){									
            db.collection(path.name).onSnapshot(res => {									
                        const changes = res.docChanges();									
                        changes.forEach(change => {									
                          if (change.type === 'added') {									
                              let returnobj = {									
                              ...change.doc.data(),									
                              id: change.doc.id									
                            }									
                            //console.log(typeof this.SystemAssets)									
                            // returnobj.Library = path.meta.subcat									
                            let check = this.GalleryLibraries.find(obj => obj.name === path.meta.subcat)									
                            if(!check){									
                                let libraryobj = {									
                                    name: path.meta.subcat,									
                                    compname: path.meta.subcat.split(' ').join(''),									
                                    Assets: []									
                                }	
                                let libentity = this.SystemPhotoLibraries.find(obj => obj.id === path.meta.EntityID)	
                                if(libentity){
                                    if(libentity.CustomTags){
                                      libraryobj.CustomTags = libentity.CustomTags  
                                    }
                                    libraryobj.TableCollectionRef = db.collection(libentity.id.split('_').join('').toLowerCase())	                                    
                                }	
                                	//console.log('libraryobj',libraryobj)				
                                libraryobj.Assets.push(returnobj)									
                                this.GalleryLibraries.push(libraryobj)									
                            }									
                            else{									
                                check.Assets.push(returnobj)									
                            }									
                            //console.log(this.GalleryLibraries)									
                            									
                          }									
                        })									
                      })									
        },	
        PrepNavbar(newvalue){
            if(this.IsGroupView){
                this.SelectedNavbar = this.NavbarItems.find(obj => obj.Name === 'Group')
            }
            else{
                this.SelectedNavbar = {Name: 'Social',Prop: 'SocialNavbarItems',PublishType: 'Members Only'}
            }
            if(!this[this.NavlistHolder][this.SelectedNavbar.Prop]){
                this[this.NavlistHolder][this.SelectedNavbar.Prop] = []
            }
        },
        //['ShowTabElements','HideTabElements','OpenDialog','AdjustRowAmount','Elmntdragstart','Elmntdragfinish','NoPropsemit','blockdragstart']
        // /AssignSocialItemInteractMethod(item,SecondProp)

        CancelNavItemDrag(){
            this.NavItemIndex = -1
        },
        NavItemDragStart(index){
            this.NavItemIndex = index
        },		
        NavItemDragFinish(index){
            this.NavListArray.splice(index,0, this.NavListArray.splice(this.NavItemIndex, 1)[0])
        },
        UpdateContentEditableField(prop,value,AdditionalSaveMethod,FieldObject){
            FieldObject[prop] = value
            console.log(AdditionalSaveMethod)
            if(AdditionalSaveMethod){
                this[AdditionalSaveMethod]()
            }
        },
        DeactivateSEODialog(){
            this.SEOBasicsDialog = false
            this.SEOPage = Object.assign({},this.DefaultSEOPage)
        },
        UpdateSEOBasics(){
            let updatepath = ''
            if(this.$route.name === 'PageEditor'){
                updatepath = db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('Pages').doc(this.SEOPage.id)
            }
            else if(this.IsGroupView){
                updatepath = db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).collection('pages').doc(this.SEOPage.id)
            }
            updatepath.update({
                Overview: this.SEOPage.Overview,
                KeyWords: this.SEOPage.KeyWords,
                SEO: this.SEOPage.SEO
            }).then(updatedpage => {
                this.DeactivateSEODialog()
            })
        },
        ActivateSEOBasicsDialog(page){
            this.SEOPage = {
                Overview: page.Overview,
                KeyWords: [],
                PageRoute: page.PageRoute,
                Name: page.Name,
                Icon: page.PageIcon,
                id: page.id,
                SEO: false,
            }
            if(page.KeyWords){
                this.SEOPage.KeyWords = page.KeyWords
            }
            if(page.SEO){
                this.SEOPage.SEO = page.SEO
            }
            this.SEOBasicsDialog = true
        },
        ChangePageProp(page,Prop){
        },
        UpdatePageProp(page,Prop){
            let updatepath = ''
            if(this.$route.name === 'PageEditor'){
                updatepath = db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('Pages').doc(page.id)
            }
            else if(this.IsGroupView){
                updatepath = db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).collection('pages').doc(page.id)
            }
            updatepath.update({
                [Prop]: page[Prop]
            })
        },
        ActivatePageBGDialog(){
            this.$store.commit('setGalleryLibraries',this.GalleryLibraries)
            this.$store.commit('setGalleryAssets',this.SystemAssets)
            this.$store.commit('setEditedTab','')
            this.$store.commit('setIMGProp','PageBGAsset')
            this.$store.commit('SetSocialItemInteractMethod','ToggleGalleryDialog')
        },
        ActivateFullGallery(){
            this.$store.commit('setGalleryLibraries',this.GalleryLibraries)
            this.$store.commit('setGalleryAssets',this.SystemAssets)
            this.$store.commit('setEditedTab','')
            this.$store.commit('SetSocialItemInteractMethod','ToggleGalleryDialog')
        },
        RemovePagefromNavlistArray(page){
            let item = this[this.NavlistHolder][this.SelectedNavbar.Prop].find(obj => obj.title === page.Name)
            if(item){
                item.OnMenu = false
                item.MenuIndex = 100000
                let index = this[this.NavlistHolder][this.SelectedNavbar.Prop].indexOf(item)
                this[this.NavlistHolder][this.SelectedNavbar.Prop].splice(index,1)
            }
            this.SelectedMainDialog = false
            setTimeout(() => {
                    this.SelectedMainDialog = true
            }, 10);
            this[this.NavlistHolder][this.SelectedNavbar.Prop]
        },
        PushPagetoNavlistArray(page){
            
            let navpage = {
                id: page.id,
                Path: page.PageRoute,
                title: page.Name,
                MenuIndex: this[this.NavlistHolder][this.SelectedNavbar.Prop].length
            }
            if(page.PageIcon){
                navpage.icon = page.PageIcon
            }
            this[this.NavlistHolder][this.SelectedNavbar.Prop].push(navpage)
            this.SelectedMainDialog = false
            setTimeout(() => {
                    this.SelectedMainDialog = true
            }, 10);
            console.log(this[this.NavlistHolder][this.SelectedNavbar.Prop])
        },
        UpdateMenu(){
            if(this.NavListArray){
             this.NavlistRef.update({
                [this.SelectedNavbar.Prop]: this.NavListArray
            })   
            }
            
        },
        PageClass(page){
            if(this.SelectedPage.Name === page.Name){
                if(this.$vuetify.theme.dark){
                   return 'background lighten-2 sitenavitem' 
                }                
            }
            else{
                if(this.$vuetify.theme.dark){
                return 'background sitenavitem'
                }
                else{
                 return 'sitenavitem'   
                }
            }
        },
        
        AddNewPage(navbar){
            console.log(navbar)
            let pageitems =  [{
            title: 'Create Website Page',
            icon: 'mdi-search-web',
            ItemPass: true,
            Method: 'AssignSocialItemInteractMethod',
            Prop: 'ToggleNewPageDialog',
            SecondProp: 'Public'
          },
          {
            title: 'Create Social Page',
            icon: 'mdi-search-web',
            ItemPass: true,
            Method: 'AssignSocialItemInteractMethod',
            Prop: 'ToggleNewPageDialog',
            SecondProp: 'Members Only'
          },]
          if(this.$route.name === 'GroupPageEditor'){
              let pubtype = ''
              if(this.ActiveGroup.GroupPrivacy === 'Public'){
                  pubtype = 'Public'
              }
              else{
                  pubtype = 'Members Only'
              }
              this.AssignSocialItemInteractMethod('ToggleNewPageDialog',pubtype)
          }
          else{
              let item = pageitems.find(obj => obj.SecondProp === navbar.PublishType)
              this.AssignSocialItemInteractMethod('ToggleNewPageDialog',navbar.PublishType)
          }
        },
        AssignSocialItemInteractMethod(item,SecondProp){
        //console.log('AssignSocialItemInteractMethod',item,SecondProp)
        this.$store.commit('SetSocialItemInteractMethodProp','') 
        this.$store.commit('SetSocialItemInteractMethod','')
        if(SecondProp){
            this.$store.commit('SetSocialItemInteractMethodProp',SecondProp) 
            this.$store.commit('SetSocialItemInteractMethod',item)
        }
        else if(item){
            this.$store.commit('SetSocialItemInteractMethod',item)
        }
        },
        AssignRenderedContentBlocks(blocks){
            //console.log('sure we assign blocks',blocks)
            //THIS BECOMES STORE COMMIT
            this.RenderedContentBlocks = blocks
        },
        NavigatetoDocumentLibraryEditor(entityid){
             if(entityid !== this.$route.params.id){
                if(this.IsGroupView){
                    this.$router.replace({name: 'GroupWebFormEditor', query: {GroupID: this.GroupID},params: {id: entityid}})  
                }
                else{
                    this.$router.push('/WebFormEditor/'+entityid)
                }
             }        
        },
         NavigatetoWebFormEditor(entityid){
             if(entityid !== this.$route.params.id){
                if(this.IsGroupView){
                    this.$router.replace({name: 'GroupWebFormEditor', query: {GroupID: this.GroupID},params: {id: entityid}})  
                }
                else{
                    this.$router.push('/WebFormEditor/'+entityid)
                }
             }        
        },
        NavigatetoWebFormBuilder(){
            if(this.IsGroupView){
             this.$router.replace({name: 'GroupWebFormBuilder', query: {GroupID: this.GroupID}})   
            }
            else{
                this.$router.push('/WebFormBuilder-New')
            }
            
            // let routeData = this.$router.resolve({name: 'GroupWebFormBuilder', query: {GroupID: this.GroupID}});
            // window.open(routeData.href, '_blank');
        },
        ActivateSelectedMain(main,frompredial){
            if(this.$route.name === 'GettingStarted' || main.Route || this.$route.name === 'MyAccount'){
                //console.log('was on route')
            }
            else{
                //console.log('had ro reroute')
                this.$router.push('/Getting-Started')
            }
            //console.log(main)
            if(main.PreDialog && !frompredial){
                this.SelectedMain = main
            }
            else if(main.SecondProp && main.SecondProp.PreDialog && !frompredial){
                this.SelectedMain = main
            }
            else if(main.Method){
                this.SelectedMainDialog = false
                this.SelectedMain = ''
                let prop = main.SecondProp
                if(main.PropisSelf){
                    prop = main
                }
             this.AssignSocialItemInteractMethod(main.Method,prop)   
            }
            else if(main.Route){
                this.$router.push('/'+main.Route)
            }
            else{
                this.SelectedMain = main
            }
            //console.log(main,this.SelectedMain)
        },
        SelectOtherPage(page){
            this.EditOtherPage(page)
        },
        EditOtherPage(SelectedPage){
            if(this.IsGroupView){
                this.$router.push('/Group-PageEditor/'+this.GroupID+'/'+SelectedPage.id)
            }
            else{
                this.$router.push('/PageEditor/'+SelectedPage.id)
            }
        },
        
        AddContentDialog(EditedTab){
            if(EditedTab.ContentDialogType){
                let contentbox = this.ContentBlocks.find(obj => obj.Name === EditedTab.ContentDialogType.Name)
                EditedTab.ContentDialogBox = Object.assign({},contentbox)
                EditedTab.ContentDialogBox.Elevation = 0
                EditedTab.ContentDialogBox.Tile = true
                EditedTab.ContentDialogBox.Flat = true
                EditedTab.ContentDialogBox.IsContentDialog = true
            }
        },
    }
}
</script>

<style>

</style>



